// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';

import { CONSENT_MODES } from '@ion/api/consent-modes/modes';
import effectiveConsentMode from '@ion/api/consent-modes/utils/effectiveConsentMode';
import { MrText } from '@ion/components';

import { useConsentModeEnabled } from 'app/components/consent-mode-select/GatedConsentModeSelect';

import allowRowClick from './allow-row-click';

const MODE_LABELS = {
  [CONSENT_MODES.ace]: 'Advanced Consent Enforcement',
  [CONSENT_MODES.external]: 'External',
};

function determineStyleNames(row) {
  const stagedMode = effectiveConsentMode(row.consentMode);
  const deployedMode = effectiveConsentMode(row.deployedConsentMode);
  const isSemiBold = row.deployedRevision && deployedMode !== stagedMode;
  if (isSemiBold) {
    return 'sm semiBold';
  }
  return 'sm';
}

export default function ConsentModeCell(row) {
  const { consentModeEnabled } = useConsentModeEnabled();
  if (!consentModeEnabled) {
    return null;
  }

  const styleNames = determineStyleNames(row);
  const label = MODE_LABELS[effectiveConsentMode(row.consentMode)] ?? '-';

  return (
    <MrText component="span" styleNames={styleNames} {...allowRowClick}>
      {label}
    </MrText>
  );
}
